import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class FastFilter extends React.Component {
  static propTypes = {
    /** Classname to be applied to <FastFilter> */
    className: PropTypes.string,
    /** Allow multiple active filters */
    allowMultipleFilters: PropTypes.bool,
    /** List of filters to be rendered */
    filters: PropTypes.PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        selected: PropTypes.bool,
        defaultSelected: PropTypes.bool,
      }),
    ).isRequired,
    /** Callback function for filter updates. fn(id: string) */
    onChange: PropTypes.func,
  };

  static defaultProps = {
    filters: [],
    className: '',
    allowMultipleFilters: false,
  };

  state = {
    activeFilters: {},
    defaultSelected: undefined,
  };

  componentDidMount() {
    const { filters } = this.props;

    filters.forEach(filter => {
      if (filter.defaultSelected) {
        this.setState({ defaultSelected: filter.id, activeFilters: { [filter.id]: true } });
      }
      if (filter.selected) {
        this.setActiveFilter(filter.id);
      }
    });
  }

  setActiveFilter = (id, cb = () => {}) => {
    // talk to zach if we should no-op clicking on the same button again
    this.setState(
      prevState => ({
        activeFilters: {
          ...(this.props.allowMultipleFilters
            ? { ...prevState.activeFilters, [id]: prevState.activeFilters[id] === null ? true : !prevState.activeFilters[id] }
            : {}),
          ...(!this.props.allowMultipleFilters ? { [id]: prevState.activeFilters[id] === null ? true : !prevState.activeFilters[id] } : {}),
          ...(!this.props.allowMultipleFilters && prevState.defaultSelected && !prevState.activeFilters[id] === false
            ? { [prevState.defaultSelected]: true }
            : {}),
        },
      }),
      () => {
        cb();
      },
    );
  };

  handleOnChange = id => {
    this.setActiveFilter(id, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.activeFilters);
      }
    });
  };

  render() {
    const { filters, className } = this.props;
    const rootClass = classNames({
      'fast-filter': true,
      [className]: true,
    });

    return (
      <div className={rootClass}>
        {filters.map(({ id, label, value }) => (
          <button
            className={classNames({
              'fast-button': true,
              'disable-click': !this.props.allowMultipleFilters && this.state.activeFilters[id],
            })}
            key={id}
            title={`Filter table to show ${label} results only`}
            aria-label={`${value} ${label} results`}
            aria-pressed={this.state.activeFilters[id] ? true : false}
            aria-disabled={this.state.activeFilters[id] ? true : false}
            onClick={() => this.handleOnChange(id)}>
            <span className={classNames({ 'fast-value': true, active: this.state.activeFilters[id] })}>{value}</span>
            <span className="fast-label">{label}</span>
          </button>
        ))}
      </div>
    );
  }
}

export default FastFilter;
